import { Menu, Schedule } from '.';
import { PicVersion } from './abstract/pic-version.entity';

export class Dish {

    // *********************
    // Key Info
    // *********************

    _id?: string;

    // *********************
    // Status Info
    // *********************

    /**
     *  '0':正常
     *  '1'：下架
     *  '2'：沽清
     */
    status?: string;

    // *********************
    // Basic Info
    // *********************

    name?: string;


    price?: number;

    description?: string;


    quantity_description?: string;

    // 菜品图片
    pics?: Array<PicVersion>;

    // 菜品位置
    position?: number;

    position_subscript?: number;

    // 所属菜单信息
    asssigned_menus?: Array<Pick<Menu, '_id' & 'name'>>;

    // 菜品标识 0:菜品，1：包餐, 2:套餐 3:调味品（只用于2.0） 4:游乐项目
    dish_type?: string;

    // 菜品标签 1:厨师推荐（Hot) 2:新品推荐(New) 3:折扣（Sale)
    special_type?: string;

    // *********************
    // Lables
    // *********************

    // 过敏原
    allergen?: Array<string>;

    // 配料
    ingredients?: Array<string>;

    // *********************
    // Setting
    // *********************

    setting_tax_group_id?: string;

    // 菜单创建时间
    create_time?: Date;

    setting_special_dish?: boolean;

    /**
     * delivery_type支持配送类型
     * 0: 外送
     * 1: 自取
     * 2: 外送+自取
     * 3: 堂食
     * 4：堂食+自取
     * 5：堂食+外送
     * 6：堂食+自取+外送
     * undefind: 堂食+自取+外送
     * 默认为全支持
     */
    delivery_type?: string;

    // 没有折扣(true:不参与折扣，false|undefined:参与折扣)
    is_no_discount?: boolean;

    // 菜品图片
    realpics?: Array<string>;

    buyNumber?: number;

    // *********************
    // Coustorm key
    // *********************

    // 餐品列表
    dishs?: Array<Dish>;

    // 备注
    remark?: string;

    // 混合id
    firstId?: string;

    // 菜品对应的分类Id
    menuId?: string;

    // 菜单名
    menuName?: string;

    // 前端用集合性商品id
    collectiveId?: string;

    // *********************
    // Shark Info
    // *********************
    // 标记此菜品是否是来源于另外一个项目

    origin_type?: string;

    // 标记此菜品在另外一个项目的唯一标识码

    origin_id?: string;

    // 上次同步的时间

    origin_synchronize_date?: Date;

    // 菜品详情（套餐内区域的菜品）
    dishInfo?: Dish;

    // *********************
    // 前端辅助字段
    // *********************

    /**
     * 过滤器状态（allergen过敏源、ingredients其他菜品标识）
     */
    filter_status?: boolean;

    /**
     * 启用积分模式
     */
    is_points_redemption?: boolean;
    // 可用营业表
    availableSchedule?: Schedule[];
    // 是否不可用
    unavailableTime?: boolean;

    // 时长
    actual_meal_time?: string;
}